import { Inbox } from 'lucide-react';

export const EmptyState = ({ title = 'Sin datos aún', description = 'Cuando haya información disponible la verás aquí.', action }) => (
    <div className="rounded-2xl border border-dashed border-border bg-white p-10 text-center">
        <div className="mx-auto size-12 rounded-2xl bg-secondary inline-flex items-center justify-center"><Inbox className="size-6 text-muted-foreground" /></div>
        <h3 className="mt-3 font-display font-semibold">{title}</h3>
        <p className="mt-1 text-sm text-muted-foreground max-w-md mx-auto">{description}</p>
        {action ? <div className="mt-4">{action}</div> : null}
    </div>
);

export default EmptyState;
